import React, { useState } from "react";
import SectionContainer from "../SectionContainer";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";

import styles from "./PropertyAboutSection.module.scss";
import Button from "@Components/Button";
import PropertyDetailsModal from "../PropertyDetailsModal";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { PAGE } from "constants/configConstants";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import replaceAmberDomainInLinks from "@Utils/clientUtils/dangerouslySetInnerHtmlUtility/replaceAmberDomainInLinks";
import stripBlogLinks from "@Utils/clientUtils/dangerouslySetInnerHtmlUtility/stripBlogLinks";
import useNoindexSlugs from "hooks/useNoindexSlugs";
import { stripNoindexLinks } from "@Utils/noindexLinks";
//

const descriptionList: Record<string, any> = {
  basic: {},
  about: {},
  features: { title: "propertypage.aboutsection.featurestitle" },
  nearby_places: { title: "propertypage.aboutsection.locationtitle" },
  commute: { title: "propertypage.aboutsection.commutetitle" },
  distance: { title: "propertypage.aboutsection.distancetitle" },
  availability: { title: "propertypage.aboutsection.availabilitytitle" },
  pet_policy: { title: "propertypage.aboutsection.petpolicytitle" },
  promotions: { title: "propertypage.aboutsection.promotionstitle" },
  amenities: { title: "propertypage.aboutsection.amenitiestitle" },
  other: { title_display_name: true },
};

const PropertyAbout = ({ isDesktop = false }) => {
  const noindexSlugs = useNoindexSlugs();
  const [open, setOpen] = useState<boolean>(false);

  const { inventory } = useSelector(
    ({ propertyPageData }: AppState) => ({
      inventory: propertyPageData?.data,
    }),
    shallowEqual,
  );

  let aboutSectionHtml = "";
  inventory?.description?.forEach((item: any) => {
    if ((item?.name_en || item?.name) === "about")
      aboutSectionHtml = item?.value.replace("<-", "-").replace("< -", "-");
  });

  const renderContent = (hideAbout = false) => (
    <>
      {inventory?.description?.map((item: any, index: number) => (
        <React.Fragment key={`${item?.name}-${index}`}>
          {(!hideAbout || (item?.name_en || item?.name) !== "about") &&
            descriptionList[item?.name_en || item.name] &&
            item.value.length > 0 && (
              <div className={styles.descriptionContainer}>
                <h3 className={styles.listHeading}>
                  {item.display_name === "Nearby places"
                    ? "Location and What's Hot?"
                    : item.display_name}
                </h3>
                <div
                  className={styles.modalContent}
                  dangerouslySetInnerHTML={{
                    __html: stripBlogLinks(
                      replaceAmberDomainInLinks(stripNoindexLinks(item.value, noindexSlugs)),
                    ),
                  }}
                />
              </div>
            )}
        </React.Fragment>
      ))}
    </>
  );
  const { t } = useTranslationHook();
  const toggleShowMore = () => {
    setOpen(true);
    gtagEventEmitter({
      action: "viewed_description",
      category: PAGE.INVENTORY,
      label: "success",
    });
  };

  if (!aboutSectionHtml) return <></>;

  return (
    <>
      {/* @ts-ignore */}
      <SectionContainer
        title={t("propertypage.aboutsection.abouttitlestring")}
        id="description"
        className={formatClassNames(styles.aboutSectionContainer, isDesktop && styles.desktop)}
        isDesktop={isDesktop}
        showTitleLine
        headingLevel={2}
      >
        <div
          data-testid="property-detail-description"
          className={formatClassNames(styles.aboutSection, isDesktop && styles.aboutSectionDesktop)}
          dangerouslySetInnerHTML={{
            __html: stripBlogLinks(
              replaceAmberDomainInLinks(stripNoindexLinks(aboutSectionHtml, noindexSlugs)),
            ),
          }}
        />
        <div className={styles.hidden}>
          {/** For SEO */}
          {renderContent(true)}
        </div>
        <>
          <Button
            variant="showAll"
            onClick={toggleShowMore}
            isDesktop={isDesktop}
            className={styles.button}
            dataTestId="property-description-showAll"
          >
            <div className={styles.subText}>{t("propertypage.aboutsection.showmore")}</div>
          </Button>
        </>
        {open && (
          <PropertyDetailsModal
            header={t("propertypage.aboutsection.abouttitlestring")}
            actionButtonText={t("bookingpage.components.modalactionbutton.gotit")}
            hidePropertyModal={() => setOpen(false)}
            isDesktop={isDesktop}
            sidePanel
            removeFooter={isDesktop}
          >
            <div>{renderContent()}</div>
          </PropertyDetailsModal>
        )}
      </SectionContainer>
    </>
  );
};

export default wrapperHOC(PropertyAbout, {
  componentName: "PropertyAbout-PropertyPage",
  showForChina: true,
});
